<template>
  <div>
    <div class="row" v-for="(name,idx) in dataArr" :key="idx">
      <div class="col-1">
        <label for="name">{{ idx }}</label>
      </div>
      <div class="col-7">
        <div class="form-group">
          <input class="form-control discountLbl" :id="'thickness-name-' + idx" v-model="dataArr[idx]" @keyup="updateThicknessData()"/>
        </div>
      </div>
      <div class="col-4">
        <button class="btn btn-danger" @click="deleteThicknessData(idx)">
          <span class="spinner-border spinner-border-sm spinDel d-none" :id="'spinnerThickness_'+idx" role="status" aria-hidden="true"></span>
          Delete
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-12 text-right">
        <button class="btn btn-primary" @click="addThicknessData">
          <span class="spinner-border spinner-border-sm spinAdd d-none" id="spinnerAddThickness" role="status" aria-hidden="true"></span>
          Add
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// Reconstructed 2026-10-05 from the compiled admindev build (built 2026-05-29):
// this file was never committed. Replace with Matt's original when he pushes it.

import {mapGetters} from "vuex";

export default {
  name: "Thickness",
  data() {
    return {
      dataArr: []
    };
  },
  emits: {
    updateThickness: null
  },
  computed: {
    ...mapGetters({
      'thicknessData': 'product/getThicknessData',
    }),
  },
  methods: {
    addThicknessData() {
      document.querySelector('#spinnerAddThickness').classList.remove('d-none');
      this.$store.dispatch('product/addThickness', {name: '*******', active: 1}).then(rez => {
        this.dataArr[rez.id] = rez.name
        this.$emit('updateThickness', this.dataArr)
        document.querySelector('#spinnerAddThickness').classList.add('d-none');
      })
    },
    deleteThicknessData(id) {
      document.querySelector('#spinnerThickness_'+id).classList.remove('d-none');
      this.$store.dispatch('product/deleteThickness', {id}).then(rez => {
        if(rez.success) {
          delete this.dataArr[id]
          this.$emit('updateThickness', this.dataArr)
        }
        document.querySelector('#spinnerThickness_'+id).classList.add('d-none');
      })
    },
    updateThicknessData() {
      this.$emit('updateThickness', this.dataArr)
    }
  },
  mounted() {
    this.dataArr = this.thicknessData
    this.$store.dispatch('product/getThickness').then(() => {
      this.dataArr = this.thicknessData
      this.$emit('updateThickness', this.dataArr)
    })
  }
};
</script>
<style scoped>

.spinDel{
  position: absolute;
  left:35px;
  top:10px;
}

.spinAdd{
  position: absolute;
  top:10px;
}

</style>
